import React, { Component } from "react";
import { connect } from "react-redux";
//import { withTranslation } from 'react-i18next'; // Not being used, so commented out

import { incPrediction, decPrediction } from "./store/actions";
import styles from "./style.module.scss";

/**
 * Controls Component - Responsible for handling volume controls.
 */
class Controls extends Component {
  // Component state
  state = {
    pressed: false,
  };

  /**
   * Handles the state change based on user interactions.
   *
   * @param {boolean} incrementing - If true, will trigger incrementing function, otherwise decrementing.
   * @param {Object} e - The event object.
   */
  handleStateChange = (incrementing, e) => {
    const typesToPress = ["mousedown", "keydown"];
    const typesToRelease = ["mouseup", "mouseout", "keyup"];
    const method = incrementing ? this.inc : this.dec;

    // Handle key presses and mouse down events
    if (
      typesToPress.includes(e.type) &&
      (e.type !== "keydown" || e.key === "Enter" || e.key === " ")
    ) {
      this.setState({ pressed: true }, () => {
        requestAnimationFrame(method);
      });
    }
    // Handle key releases and mouse up/out events
    else if (typesToRelease.includes(e.type)) {
      this.setState({ pressed: false });
    }
  };

  /**
   * Triggers incrementing prediction if "pressed" is true.
   */
  inc = () => {
    if (this.state.pressed) {
      this.props.incPrediction({ index: this.props.index });
      requestAnimationFrame(this.inc);
    }
  };

  /**
   * Triggers decrementing prediction if "pressed" is true.
   */
  dec = () => {
    if (this.state.pressed) {
      this.props.decPrediction({ index: this.props.index });
      requestAnimationFrame(this.dec);
    }
  };

  // Render method
  render() {
    return (
      <div className={styles.controls}>
        <div className={styles.volumeControl}>
          <button
            style={{ cursor: "pointer" }}
            //aria-label={this.props.t("Decrease volume button")} // Uncomment when ready for translation
            onMouseDown={(e) => this.handleStateChange(false, e)}
            onMouseUp={(e) => this.handleStateChange(false, e)}
            onMouseOut={(e) => this.handleStateChange(false, e)}
            onBlur={(e) => this.handleStateChange(false, e)}
            onKeyDown={(e) => this.handleStateChange(false, e)}
            onKeyUp={(e) => this.handleStateChange(false, e)}
          >
            {" "}
            -{" "}
          </button>

          <button
            style={{ cursor: "pointer" }}
            //aria-label={this.props.t("Increase volume button")} // Uncomment when ready for translation
            onMouseDown={(e) => this.handleStateChange(true, e)}
            onMouseUp={(e) => this.handleStateChange(true, e)}
            onMouseOut={(e) => this.handleStateChange(true, e)}
            onBlur={(e) => this.handleStateChange(true, e)}
            onKeyDown={(e) => this.handleStateChange(true, e)}
            onKeyUp={(e) => this.handleStateChange(true, e)}
          >
            {" "}
            +{" "}
          </button>
        </div>
      </div>
    );
  }
}

// Connect the component to the Redux store
export default connect(null, { incPrediction, decPrediction })(Controls);
